import React from "react"
import {connect} from "react-redux";
import {fetchStatus} from "../../actions/statusActions";
import Loader from "../Loader";

class Status extends React.Component {

    componentWillMount() {
        this.props.fetchStatus('status')
    }

    render() {
        return <div>
            {this.props.fetching && <Loader/>}
            <pre>{JSON.stringify(this.props.status, null, 4)}</pre>
        </div>
    }
}
// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
    fetchStatus: (option) => dispatch(fetchStatus(option))
})

const mapStateToProps = (state) => ({
    fetching: state.status.fetching,
    status: state.status,
})

export default connect(mapStateToProps, mapDispatchToProps)(Status)


// WEBPACK FOOTER //
// ./src/components/Status/Status.js